<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="17"
        viewBox="0 0 15 17"
        fill="none"
    >
    <path
        d="M10.526 7.2267L15 8.55441L10.526 9.88211C9.66882 10.1366 8.99349 10.8521 8.75323 11.7602L7.49999 16.5L6.24675 11.7602C6.00649 10.8521 5.33116 10.1366 4.47401 9.88211L0 8.55441L4.47401 7.2267C5.33116 6.97217 6.00649 6.25672 6.24675 5.34865L7.49999 0.500381L8.75323 5.34865C8.99349 6.25672 9.66882 6.97217 10.526 7.2267Z"
        fill="white"
    />
    </svg>
</template>